module.exports = __webpack_public_path__ + "img/sysmonitorselect.85b5110d.svg";